module.exports = __webpack_public_path__ + "static/media/home-bk-wall.96e21fb4.jpg";